import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@chakra-ui/react';

const Auth0LoginButton = () => {
  const { loginWithRedirect, isLoading } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({
      appState: {
        returnTo: window.location.pathname
      }
    });
  };

  return (
    <Button
      onClick={handleLogin}
      isLoading={isLoading}
      colorScheme="blue"
      size="lg"
      width="250px"
    >
      Log in
    </Button>
  );
};

export default Auth0LoginButton;
